/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './prescription.reducer';

export const PrescriptionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const prescriptionEntity = useAppSelector(state => state.prescription.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="prescriptionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.prescription.detail.title">Prescription</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.prescription.id">Id</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.id}</dd>
          <dt>
            <span id="tmDate">
              <Translate contentKey="tinyMedicRestApp.prescription.tmDate">Tm Date</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.tmDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.prescription.active">Active</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.prescription.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.prescription.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.prescription.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.prescription.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.cursor}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.prescription.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.patientType}</dd>
          <dt>
            <span id="exposed">
              <Translate contentKey="tinyMedicRestApp.prescription.exposed">Exposed</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.exposed ? 'true' : 'false'}</dd>
          <dt>
            <span id="approved">
              <Translate contentKey="tinyMedicRestApp.prescription.approved">Approved</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.approved ? 'true' : 'false'}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.prescription.status">Status</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.status}</dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="tinyMedicRestApp.prescription.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.orderStatus}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.prescription.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.prescription.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.prescription.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.prescription.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{prescriptionEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescription.issuedBy">Issued By</Translate>
          </dt>
          <dd>{prescriptionEntity.issuedBy ? prescriptionEntity.issuedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescription.patient">Patient</Translate>
          </dt>
          <dd>{prescriptionEntity.patient ? prescriptionEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescription.appointment">Appointment</Translate>
          </dt>
          <dd>{prescriptionEntity.appointment ? prescriptionEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescription.treatmentPlan">Treatment Plan</Translate>
          </dt>
          <dd>{prescriptionEntity.treatmentPlan ? prescriptionEntity.treatmentPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescription.approvedBy">Approved By</Translate>
          </dt>
          <dd>{prescriptionEntity.approvedBy ? prescriptionEntity.approvedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/prescription" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/prescription/${prescriptionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PrescriptionDetail;
